export const user_guides = {
  "user_guides.setGuideFile": "user_guides.setGuideFile",
  "user_guides.getGuideFile": "user_guides.getGuideFile",
} as const;
